"use strict";

require("core-js/modules/es.array.iterator");

var zipWithIndexL = require("../Lazy/zipWithIndexL.js");

var defaultTo = require("./defaultTo.js");

var go = require("./go.js");

var go1 = require("./go1.js");

var head = require("./head.js");

var find = require("./find.js");

const findIndex = (f, iter) => go(iter, zipWithIndexL, find(([_i, a]) => go1(a, f)), defaultTo([-1]), head);

module.exports = findIndex;